import { createStyles, makeStyles } from '@material-ui/core';

export const useMobileDrawerItemStyles = makeStyles(() =>
    createStyles({
        root: {
            'gap': 12,
            'fontSize': 14,
            'lineHeight': 1,
            'fontWeight': 500,
            'padding': '16px 0px',
            'display': 'flex',
            'alignItems': 'center',
            'backgroundColor': '#FFFFFF',

            '& svg': {
                fontSize: 17
            },

            '&:not(:last-child)': {
                borderBottom: '1px solid #D4D4D4'
            }
        }
    })
);
